module.exports = __webpack_public_path__ + "img/Companycultrue-dev.9c0aa3d1.png";